import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import robot from './modules/robot'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    app,
    robot
  },
  getters
})
